import { Button, Heading, ModalTemplate, Typography } from '@/shared/ui';

interface ConfirmModalProps {
  onConfirm?: () => void;
  onCancel?: () => void;
}
export const ResetModal = ({ onConfirm, onCancel }: ConfirmModalProps) => {
  return (
    <ModalTemplate
      id="reset-modal"
      classNames={{
        wrapper: 'rounded-[32px]',
      }}
    >
      <div className="flex flex-col pt-10">
        <div className="flex flex-col gap-y-3 px-5">
          <Heading variant="s">
            Are you sure you want to cancel the changes?
          </Heading>
          <Typography variant="14-r" color="base-300" className="text-center">
            The changes you have made will&nbsp;be&nbsp;reset
          </Typography>
        </div>
        <div className="flex w-full items-center gap-1 px-1 pb-1 pt-7">
          <Button
            variant="base-300"
            size="d-l"
            className="w-full"
            onClick={onCancel}
          >
            No, back
          </Button>
          <Button size="d-l" className="w-full" onClick={onConfirm}>
            Yes, cancel
          </Button>
        </div>
      </div>
    </ModalTemplate>
  );
};
